import { motion, useInView, AnimatePresence } from "framer-motion";
import { useEffect, useRef, } from "react";
import { useState } from "react";
import HomeBanner from "../images/nri-desktop.webm";
import { Link } from "react-router-dom";
import Logo from "../images/logo.png"
import img1 from "../images/elivation_eight.jpg";
import img2 from "../images/elivation_one.jpg";
import img3 from "../images/elivation_seven.jpg";

import masterPlanImg from "../images/masterplan.jpg"; // change path if needed

import tower1 from "../images/plan_one.jpg";
import tower2 from "../images/plan_two.jpg";
import tower3 from "../images/plan_three.jpg";
import bgImage from "../images/club-house.jpg";

import modalLeftPNG from "../images/onebymsn.png";
// Import images at the top of your file
import feature1Img from '../images/kind-1.jpg';
import feature2Img from '../images/kind-2.jpg';
import feature3Img from '../images/kind-3.jpg';
import feature4Img from '../images/kind-4.jpg';
import feature5Img from '../images/kind-5.jpg';
import feature6Img from '../images/kind-6.jpg';

import gallery1 from '../images/gal-1.jpg'
import gallery2 from '../images/gal-2.jpg'
import gallery3 from '../images/gal-3.jpg'
import gallery4 from '../images/gal-4.jpg'
import gallery5 from '../images/gal-5.jpg'
import gallery6 from '../images/gal-6.jpg'
import gallery7 from '../images/gal-7.jpg'
import gallery8 from '../images/gal-8.jpg'
import gallery9 from '../images/gal-9.jpg'
import gallery10 from '../images/gal-10.jpg'
import gallery11 from '../images/gal-11.jpg'
import gallery12 from '../images/gal-12.jpg'

import ContactForm from '../components/ContactForm'
import NeopolisImg from '../images/neopolis.png'

export default function Home({ openModal, closeModal }) {
    const hasRun = useRef(false);

    const scrollToSection = (id) => {
        const section = document.getElementById(id);
        if (!section) return;

        const headerOffset = 80;
        const elementPosition = section.getBoundingClientRect().top;
        const offsetPosition =
            elementPosition + window.pageYOffset - headerOffset;

        // Smooth scroll
        window.scrollTo({
            top: offsetPosition,
            behavior: "smooth",
        });

        // Close offcanvas safely
        const offcanvasEl = document.getElementById("offcanvasNavbar");

        if (offcanvasEl) {
            // Bootstrap way
            if (window.bootstrap) {
                const instance =
                    window.bootstrap.Offcanvas.getInstance(offcanvasEl) ||
                    new window.bootstrap.Offcanvas(offcanvasEl);

                instance.hide();
            }

            // 🔥 Fallback (important)
            offcanvasEl.classList.remove("show");
            offcanvasEl.setAttribute("aria-hidden", "true");

            // Remove backdrop manually
            const backdrop = document.querySelector(".offcanvas-backdrop");
            if (backdrop) backdrop.remove();

            // Restore body scroll
            document.body.classList.remove("offcanvas-open");
            document.body.style.overflow = "";
            document.body.style.paddingRight = "";
        }
    };



    useEffect(() => {
        // Prevent double call in React 18 StrictMode
        if (hasRun.current) return;
        hasRun.current = true;

        if (typeof openModal === "function") {
            openModal();
        }
    }, [openModal]);

    // Destination Highlight

    const highlightCounts = {
        residencesMin: 5250,
        residencesMax: 7460,
        amenitiesArea: 1.8, // lakh
        bhk: 4,
        height: 12,
    };

    const statsData = [
        { value: 7.7, label: "Acres", decimals: 1 },
        { value: 55, label: "Floors" },
        { value: 5, label: "Towers" },
        { value: 655, label: "Residences" },
        { value: 100, label: "Amenities", suffix: "+" },
    ];

    const statsRef = useRef(null);
    const isInView = useInView(statsRef);

    const [counts, setCounts] = useState(statsData.map(() => 0));

    const [highlights, setHighlights] = useState({
        residencesMin: 0,
        residencesMax: 0,
        amenitiesArea: 0,
        bhk: 0,
        height: 0,
    });

    useEffect(() => {
        let timer;

        if (isInView) {
            const duration = 1200;
            const interval = 16;
            const steps = duration / interval;
            let step = 0;

            timer = setInterval(() => {
                step++;
                const progress = Math.min(step / steps, 1);

                // Stats grid counters
                setCounts(
                    statsData.map(item => item.value * progress)
                );

                // Highlight counters
                setHighlights({
                    residencesMin: highlightCounts.residencesMin * progress,
                    residencesMax: highlightCounts.residencesMax * progress,
                    amenitiesArea: highlightCounts.amenitiesArea * progress,
                    bhk: highlightCounts.bhk * progress,
                    height: highlightCounts.height * progress,
                });

                if (step >= steps) clearInterval(timer);
            }, interval);
        } else {
            // RESET when leaving viewport
            setCounts(statsData.map(() => 0));
            setHighlights({
                residencesMin: 0,
                residencesMax: 0,
                amenitiesArea: 0,
                bhk: 0,
                height: 0,
            });
        }

        return () => clearInterval(timer);
    }, [isInView]);

    // Glimpse
    const glimpseImages = [
        {
            src: img1,
            alt: "One by MSN luxury 4 BHK apartments Neopolis Kokapet Hyderabad exterior view"
        },
        {
            src: img2,
            alt: "One by MSN Neopolis premium high rise towers skyline Hyderabad"
        },
        {
            src: img3,
            alt: "Luxury residential project One by MSN Kokapet Hyderabad master architecture"
        }
    ];

    const [selectedImage, setSelectedImage] = useState(null);

    // Masterplan
    const [selectedPlan, setSelectedPlan] = useState(null);

    // Floor Plans
    // ✅ STATE MUST BE HERE
    const images = [
        {
            src: tower1,
            alt: "One by MSN Tower AON and UNO luxury 4 BHK apartments Neopolis Kokapet Hyderabad"
        },
        {
            src: tower2,
            alt: "One by MSN Tower EKA and ODIN premium high rise residences Kokapet Hyderabad"
        },
        {
            src: tower3,
            alt: "One by MSN Tower ISA ultra luxury residential tower Neopolis Hyderabad"
        }
    ];

    const labels = ["TOWER AON & UNO", "TOWER EKA & ODIN", "TOWER ISA"];
    const [activeIndex, setActiveIndex] = useState(0);

    // One Kind
    const features = [
        {
            title: "Master bedroom redefined",
            subtitle: "750 SFT. OF UNBRIDLED LUXURY",
            img: feature1Img,
            alt: "One by MSN luxury master bedroom spacious 4 BHK apartments Neopolis Kokapet Hyderabad"
        },
        {
            title: "Masterpiece framed by your balcony",
            subtitle: "25,000 ACRES OF UNINTERRUPTED VIEWS",
            img: feature2Img,
            alt: "One by MSN balcony views luxury apartments Neopolis Kokapet Hyderabad skyline"
        },
        {
            title: "Extravagant living rooms",
            subtitle: "HOST 100 & IMPRESS 1000",
            img: feature3Img,
            alt: "One by MSN luxury living room spacious 4 BHK apartments Hyderabad"
        },
        {
            title: "Bon voyage to leisure",
            subtitle: "1,80,000 SFT. YACHT-SHAPED CLUBHOUSE, SKY PARK & AMENITIES",
            img: feature4Img,
            alt: "One by MSN yacht shaped clubhouse luxury amenities Neopolis Kokapet Hyderabad"
        },
        {
            title: "Private Lobby",
            subtitle: "PRIVATE LOBBIES FOR UNMATCHED PRIVACY AND EXCLUSIVE LIVING",
            img: feature5Img,
            alt: "One by MSN private lobby luxury 4 BHK apartments Neopolis Hyderabad"
        },
        {
            title: "Concierge Services",
            subtitle: "SOPHISTICATION SERVED. EXCLUSIVITY ENSURED",
            img: feature6Img,
            alt: "One by MSN concierge services premium luxury apartments Kokapet Hyderabad"
        }
    ];




    const [currentIndex, setCurrentIndex] = useState(0);
    const [modalImg, setModalImg] = useState(null);
    const [isPlaying, setIsPlaying] = useState(false);

    // const images = features.map(f => f.img);
    const titles = features.map(f => f.title);

    const currentTitle = titles[currentIndex];

    // Gallery
  const galleryBlocks = [
  {
    title: "Landscaped Arrival Plaza",
    img: gallery1,
    alt: "One by MSN landscaped arrival plaza luxury apartments Neopolis Kokapet Hyderabad"
  },
  {
    title: "Indoor Temperature-Controlled Swimming Pool",
    img: gallery2,
    alt: "One by MSN indoor swimming pool luxury residential project Hyderabad"
  },
  {
    title: "Elevated Jogging & Walking Track",
    img: gallery3,
    alt: "One by MSN elevated jogging track landscaped luxury apartments Kokapet Hyderabad"
  },
  {
    title: "Kids’ Play & Activity Zone",
    img: gallery4,
    alt: "One by MSN kids play area luxury gated community Neopolis Hyderabad"
  },
  {
    title: "Luxury Concierge & Reception Lounge",
    img: gallery5,
    alt: "One by MSN concierge lounge premium luxury apartments Kokapet Hyderabad"
  },
  {
    title: "Sky Deck & Social Plaza",
    img: gallery6,
    alt: "One by MSN sky deck social plaza luxury residential project Hyderabad"
  },
  {
    title: "Indoor Games & Recreation Lounge",
    img: gallery7,
    alt: "One by MSN indoor games recreation lounge luxury apartments Hyderabad"
  },
  {
    title: "Creative Studio & Hobby Rooms",
    img: gallery8,
    alt: "One by MSN creative studio hobby rooms luxury residences Neopolis Hyderabad"
  },
  {
    title: "Aerial View of Iconic Towers",
    img: gallery9,
    alt: "One by MSN iconic high rise towers aerial view Neopolis Kokapet Hyderabad"
  },
  {
    title: "Infinity Pool with Architectural Canopy",
    img: gallery10,
    alt: "One by MSN infinity pool architectural canopy luxury apartments Hyderabad"
  },
  {
    title: "Professional Tennis Court",
    img: gallery11,
    alt: "One by MSN professional tennis court luxury residential community Hyderabad"
  },
  {
    title: "Rooftop Leisure Pool & Nightscape",
    img: gallery12,
    alt: "One by MSN rooftop leisure pool night view luxury apartments Kokapet Hyderabad"
  }
];



    // FAQ's
    const msnFaqs = [
        {
            question: "Where is One by MSN located in Hyderabad?",
            answer:
                "One by MSN is located in Neopolis, Kokapet, West Hyderabad. The project enjoys excellent connectivity to the Financial District, Gachibowli, HITEC City, Outer Ring Road, and other major business hubs, making it one of the most premium residential locations in Hyderabad."
        },
        {
            question: "What type of apartments are available at One by MSN?",
            answer:
                "One by MSN offers exclusively ultra-luxury 4 BHK apartments designed for spacious, high-end living. Each residence features expansive layouts, premium finishes, large balconies, private lobbies, and panoramic city views."
        },
        {
            question: "Is One by MSN a RERA-approved project?",
            answer:
                "Yes, One by MSN is a RERA-approved residential project. The development is registered under Telangana RERA, ensuring transparency, legal compliance, and complete buyer protection."
        },
        {
            question: "How many towers and apartments are there in One by MSN?",
            answer:
                "The project is spread across approximately 7.7 acres and comprises 5 iconic high-rise towers with around 655 exclusive luxury residences, offering low-density living and enhanced privacy."
        },
        {
            question: "What is the size range of 4 BHK apartments at One by MSN?",
            answer:
                "The ultra-luxury 4 BHK apartments at One by MSN typically range from approximately 5,250 sq. ft. to 7,460 sq. ft., making them some of the most spacious luxury homes in Neopolis, Kokapet."
        },
        {
            question: "What amenities are available at One by MSN Neopolis?",
            answer:
                "One by MSN offers world-class amenities including a 1.8 lakh sq. ft. luxury clubhouse, sky parks, swimming pools, fitness and wellness zones, landscaped gardens, children’s play areas, indoor games, concierge services, and 24/7 security."
        },
        {
            question: "Why is One by MSN considered a premium luxury project in Hyderabad?",
            answer:
                "One by MSN stands out due to its prime Neopolis location, ultra-spacious 4 BHK residences, iconic high-rise towers, luxury clubhouse, premium amenities, and proximity to Hyderabad’s Financial District, making it a top choice for elite homebuyers."
        },
        {
            question: "Is One by MSN a good investment option in Kokapet?",
            answer:
                "Yes, One by MSN is considered a strong investment opportunity due to its location in Neopolis, Kokapet—one of Hyderabad’s fastest-growing luxury corridors—with high appreciation potential and demand for premium residences."
        },
        {
            question: "How is the connectivity from One by MSN to key areas of Hyderabad?",
            answer:
                "One by MSN offers excellent connectivity to Financial District, Gachibowli, HITEC City, ORR, international schools, hospitals, and shopping destinations, ensuring convenience for both residents and working professionals."
        },
        {
            question: "Who is the developer of One by MSN?",
            answer:
                "One by MSN is developed by MSN Realty, a reputed real estate developer known for delivering premium residential projects with a focus on quality, design excellence, and customer satisfaction."
        }
    ];



    return (
        <>
            {/* Header */}
            <div className="bg-maroon">
                <nav className="navbar container navbar-dark">
                    <div className="container-fluid">
                        <Link className="navbar-brand title-font" to="/">
                            <img src={Logo} alt="One by MSN Neopolis logo" style={{ width: "120px" }} />
                        </Link>

                        <button
                            className="navbar-toggler"
                            type="button"
                            data-bs-toggle="offcanvas"
                            data-bs-target="#offcanvasNavbar"
                        >
                            <span className="navbar-toggler-icon"></span>
                        </button>

                        <div
                            className="offcanvas offcanvas-end bg-maroon"
                            id="offcanvasNavbar"
                            tabIndex="-1"
                        >
                            <div className="offcanvas-header flex-column align-items-start w-100">

                                {/* LOGO */}
                                <img src={Logo} alt="One by MSN Neopolis Logo" style={{ width: "120px" }} />

                                {/* Divider */}
                                <hr className="mx-auto text-white opacity-50" style={{ width: "80%" }} />

                                {/* CLOSE */}
                                <button
                                    className="btn-close btn-close-white position-absolute top-0 end-0 m-3"
                                    data-bs-dismiss="offcanvas"
                                    aria-label="Close"
                                />
                            </div>

                            <div className="offcanvas-body">
                                <ul className="navbar-nav gap-2">

                                    <li className="nav-item">
                                        <button
                                            className="nav-link btn btn-link text-start"
                                            onClick={() => scrollToSection("overview")}
                                        >
                                            Overview
                                        </button>
                                    </li>

                                    <li className="nav-item">
                                        <button
                                            className="nav-link btn btn-link text-start"
                                            onClick={() => scrollToSection("one-of-a-kind")}
                                        >
                                            One of a Kind
                                        </button>
                                    </li>

                                    <li className="nav-item">
                                        <button
                                            className="nav-link btn btn-link text-start"
                                            onClick={() => scrollToSection("highlights")}
                                        >
                                            Highlights
                                        </button>
                                    </li>

                                    <li className="nav-item">
                                        <button
                                            className="nav-link btn btn-link text-start"
                                            onClick={() => scrollToSection("master-plan")}
                                        >
                                            Master Plan
                                        </button>
                                    </li>

                                    <li className="nav-item">
                                        <button
                                            className="nav-link btn btn-link text-start"
                                            onClick={() => scrollToSection("gallery")}
                                        >
                                            Gallery
                                        </button>
                                    </li>

                                    <li className="nav-item">
                                        <button
                                            className="nav-link btn btn-link text-start"
                                            onClick={() => scrollToSection("contact")}
                                        >
                                            Contact
                                        </button>
                                    </li>

                                </ul>

                                {/* CTA */}
                                <button
                                    className="btn btn-warning w-100 mt-4 fw-semibold"
                                    onClick={() => scrollToSection("contact")}
                                >
                                    Enquire Now
                                </button>
                            </div>
                        </div>
                    </div>
                </nav>
            </div>

            {/* Banner Section */}
            <motion.div
                className="text-center"
                id="overview"
                initial={{ opacity: 0, y: 40 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
            >
                <video
                    src={HomeBanner}
                    autoPlay
                    muted
                    loop
                    playsInline
                    className="w-100 banner-video"
                />
            </motion.div>

            <section className="seo-hero-text container text-center py-5">
                <h1 className="glimpse-heading title-font billie-eilish">
                    One by MSN Ultra Luxury 4 BHK Apartments in Neopolis, Kokapet Hyderabad
                </h1>

                <p className="glimpse-subtext mt-3">
                    One by MSN Realty’s ultra luxury 4 BHK apartments in Neopolis, Kokapet offer an unrivaled premium living experience in Hyderabad’s  prestigious residential and investment address. Set across 7.7+ acres with iconic high-rise towers, this RERA-approved development blends modern design, premium finishes, and world-class amenities.
                </p>
            </section>


            {/* Glimpse */}
            {/* GLIMPSE SECTION */}
            <section className="glimpse-section py-5" id="one-of-a-kind">
                <div className="container">

                    {/* Heading */}
                    <motion.div
                        className="text-center mb-5"
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                    >
                        <h2 className="glimpse-heading title-font billie-eilish">
                            About One by MSN Realty – Neopolis Hyderabad
                        </h2>

                        <div className="glimpse-divider">
                            <span></span>
                        </div>

                        <p className="glimpse-subtext mt-3">
                            <strong>One by MSN Realty</strong> is an iconic luxury residential project offering <strong>4 BHK apartments in Neopolis, Hyderabad</strong>. Designed for elite homeowners, the project combines architectural excellence, expansive layouts, and world-class amenities.
                        </p>
                    </motion.div>

                    {/* Images */}
                    <div className="row g-4">
                        {glimpseImages.map((item, index) => (
                            <motion.div
                                key={index}
                                className="col-md-4"
                                initial={{ opacity: 0, y: 40 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true }}
                                transition={{ delay: index * 0.15 }}
                            >
                                <div
                                    className="glimpse-image-wrapper"
                                    onClick={() => setSelectedImage(item.src)}
                                >
                                    <img
                                        src={item.src}
                                        alt={item.alt}
                                        loading="lazy"
                                    />
                                </div>
                            </motion.div>
                        ))}

                    </div>

                    {/* DESKTOP ACTION BUTTON (RIGHT) */}
                    <div className="d-flex justify-content-center align-items-center mt-5">
                        <button
                            className="btn bg-cream text-white fs- fw-bold d-flex align-items-center gap-2"
                            onClick={openModal}
                        >
                            <motion.span
                                animate={{ y: [0, -6, 0] }}
                                transition={{
                                    duration: 1,
                                    repeat: Infinity,
                                    ease: "easeInOut",
                                }}
                            >
                            </motion.span>

                            Download Brochure
                        </button>
                    </div>
                </div>
            </section>

            {/* Stats Section */}
            <section ref={statsRef} className="home-stats-section text-white" id="highlights">
                <div className="stats-overlay">
                    <div className="container">

                        {/* Title */}
                        <motion.div
                            className="text-center mb-5"
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                        >
                            <h2 className="stats-heading title-font display-5">Project Highlights – One by MSN Neopolis</h2>
                            <div
                                className="mx-auto mb-3"
                                style={{
                                    width: "60px",
                                    height: "2px",
                                    backgroundColor: "#d4af37"
                                }}
                            />
                            <p className="stats-subtext">
                                <strong>One by MSN</strong> is an ultra-luxury residential landmark crafted for those who seek exclusivity, space, and sophistication. Strategically located in <strong>Neopolis, Kokapet Hyderabad</strong>, this iconic development by <strong>MSN Realty</strong> redefines premium living with expansive <strong>4 BHK luxury apartments</strong>, world-class architecture, and future-ready amenities.
                            </p>
                        </motion.div>

                        {/* Highlight Numbers */}
                        <div className="row text-center mb-5 highlight-wrapper">
                            <div className="col-md-6 mb-4 highlight-item">
                                <h3 className="highlight-number">5,250 – 7,460</h3>
                                <p className="highlight-label">4 BHK Expansive Residences</p>
                            </div>

                            <div className="col-md-6 mb-4 highlight-item">
                                <h3 className="highlight-number">1.8 Lakh Sq.ft</h3>
                                <p className="highlight-label">Clubhouse & Sky Amenities</p>
                            </div>
                        </div>

                        {/* Highlights Section */}
                        <div className="highlights-section">

                            {/* Stats Grid */}
                            <div className="row text-center g-4">
                                {statsData.map((item, i) => (
                                    <motion.div
                                        className="col-6 col-md"
                                        key={i}
                                        initial={{ opacity: 0, y: 30 }}
                                        whileInView={{ opacity: 1, y: 0 }}
                                        viewport={{ once: true }}
                                        transition={{ delay: i * 0.1 }}
                                    >
                                        <div className="stat-box">
                                            <h4>
                                                {item.decimals
                                                    ? counts[i].toFixed(item.decimals)
                                                    : Math.floor(counts[i])}
                                                {item.suffix || ""}
                                            </h4>
                                            <span>{item.label}</span>
                                        </div>
                                    </motion.div>
                                ))}
                            </div>

                            {/* Extra Highlights (same hierarchy, not footer) */}
                            <div className="row text-center justify-content-center g-4 mt-4">
                                <motion.div
                                    className="col-lg-4 col-6"
                                    initial={{ opacity: 0, y: 30 }}
                                    whileInView={{ opacity: 1, y: 0 }}
                                    viewport={{ once: true }}
                                >
                                    <div className="stat-box highlight-box">
                                        <h5 className="footer-stat">4 BHK</h5>
                                        <p>Luxury Configuration</p>
                                    </div>
                                </motion.div>

                                <motion.div
                                    className="col-lg-4 col-6"
                                    initial={{ opacity: 0, y: 30 }}
                                    whileInView={{ opacity: 1, y: 0 }}
                                    viewport={{ once: true }}
                                    transition={{ delay: 0.1 }}
                                >
                                    <div className="stat-box highlight-box">
                                        <h5 className="footer-stat">12 ft</h5>
                                        <p>Floor to Floor Height</p>
                                    </div>
                                </motion.div>
                            </div>

                        </div>

                        {/* DESKTOP ACTION BUTTON (RIGHT) */}
                        <div className="d-flex justify-content-center align-items-center mt-5">
                            <button
                                className="btn bg-cream text-white fs- fw-bold d-flex align-items-center gap-2"
                                onClick={openModal}
                            >
                                <motion.span
                                    animate={{ y: [0, -6, 0] }}
                                    transition={{
                                        duration: 1,
                                        repeat: Infinity,
                                        ease: "easeInOut",
                                    }}
                                >
                                </motion.span>

                                Download Brochure
                            </button>
                        </div>
                    </div>
                </div>
            </section >

            {/* IMAGE MODAL */}
            <AnimatePresence>
                {selectedImage && (
                    <motion.div
                        className="image-modal-overlay"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                    >
                        <motion.div
                            className="image-modal-content"
                            initial={{ scale: 0.9, opacity: 0 }}
                            animate={{ scale: 1, opacity: 1 }}
                            exit={{ scale: 0.9, opacity: 0 }}
                        >
                            <button
                                className="image-modal-close"
                                onClick={() => setSelectedImage(null)}
                            >
                                ×
                            </button>

                            <img src={selectedImage} alt="One by MSN Neopolis ultra luxury residential towers skyline view" />
                        </motion.div>
                    </motion.div>
                )}
            </AnimatePresence>
            {/* ================= MASTER PLAN SECTION ================= */}
            <section id="master-plan" className="master-plan-section py-5">
                <div className="container">

                    {/* Heading */}
                    <motion.div
                        className="text-center mb-4"
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                    >
                        <h2 className="section-title text-cream title-font">Master Plan – One by MSN Neopolis, Kokapet</h2>
                        <div
                            className="mx-auto mb-3"
                            style={{
                                width: "60px",
                                height: "2px",
                                backgroundColor: "#d4af37"
                            }}
                        />
                        <div className="section-divider">
                            <span></span>
                        </div>

                        <p className="section-subtext mt-3">
                            The <strong>master plan of One by MSN</strong> is meticulously designed to deliver a seamless blend of luxury, space, and exclusivity. Located in the heart of <strong>Neopolis, Kokapet Hyderabad</strong>, this iconic residential development is spread across a vast <strong>7.7-acre landscaped campus</strong>, ensuring abundant open spaces, privacy, and an elevated lifestyle.
                        </p>
                    </motion.div>

                    {/* Image with Center Button */}
                    <motion.div
                        className="text-center"
                        initial={{ opacity: 0, scale: 0.95 }}
                        whileInView={{ opacity: 1, scale: 1 }}
                        viewport={{ once: true }}
                    >
                        <div className="row justify-content-center">
                            <div className="col-lg-10 col-xl-9">
                                <div className="master-plan-overlay-wrapper">

                                    <img
                                        src={masterPlanImg}
                                        alt="Luxury 4 BHK apartments in Kokapet Hyderabad by MSN Realty"
                                        className="img-fluid master-plan-dim"
                                    />

                                    {/* Center Button */}
                                    <button
                                        className="master-plan-center-btn"
                                        onClick={openModal}
                                    >
                                        View Full Master Plan
                                    </button>

                                </div>
                            </div>
                        </div>
                    </motion.div>

                </div>
            </section>

            {/* Floorplans */}
            {/* ================= TOWER VIEW SECTION ================= */}
            <section
                className="tower-section"
                style={{ backgroundImage: `url(${bgImage})` }}
            >
                <div className="tower-overlay ">
                    <div className="container">

                        {/* Heading */}
                        <motion.div
                            className="text-center mb-4"
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.6 }}
                        >
                            <h2 className="section-title title-font text-white">Tower View – One by MSN Neopolis, Kokapet</h2>




                            <div
                                className="mx-auto mb-3"
                                style={{
                                    width: "60px",
                                    height: "2px",
                                    backgroundColor: "#d4af37"
                                }}
                            />
                            <div className="section-divider"><span /></div>
                            <p className="section-subtext text-white mt-3">
                                The <strong>tower view at One by MSN</strong> showcases a collection of architecturally refined high-rise towers designed offer an elevated living experience. Strategically positioned within the master plan, each tower ensures maximum privacy uninterrupted views, and abundant natural light, redefining luxury high-rise living in <strong>Neopolis, Kokapet Hyderabad</strong>. Each tower is meticulously planned to complement the project’s luxury amenities and landscaped open spaces, ensuring residents experience privacy, comfort, and a prestigious lifestyle in one of Hyderabad’s most sought-after locations.
                            </p>
                        </motion.div>

                        {/* TOP BUTTONS */}
                        <motion.div
                            className="tower-tabs text-center mb-4"
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                        >
                            {labels.map((label, i) => (
                                <button
                                    key={i}
                                    className={`tower-tab ${activeIndex === i ? "active" : ""}`}
                                    onClick={() => setActiveIndex(i)}
                                >
                                    {label}
                                </button>
                            ))}
                        </motion.div>

                        {/* IMAGE */}
                        <motion.div
                            key={activeIndex}
                            initial={{ opacity: 0, scale: 0.96 }}
                            animate={{ opacity: 1, scale: 1 }}
                            transition={{ duration: 0.6, ease: "easeOut" }}
                            className="tower-image-wrapper"
                        >
                            <img
                                src={images[activeIndex].src}
                                alt={images[activeIndex].alt}
                                className="img-fluid tower-image"
                                loading="lazy"
                            />

                            <motion.button
                                className="tower-hover-btn"
                                initial={{ opacity: 0, scale: 0.9 }}
                                whileHover={{ scale: 1.05 }}
                                animate={{ opacity: 1 }}
                                onClick={openModal}
                            >
                                View Details
                            </motion.button>
                        </motion.div>

                        {/* DESKTOP ACTION BUTTON (RIGHT) */}
                        <div className="d-flex justify-content-center align-items-center mt-5">
                            <button
                                className="btn bg-cream text-white fs- fw-bold d-flex align-items-center gap-2"
                                onClick={openModal}
                            >
                                <motion.span
                                    animate={{ y: [0, -6, 0] }}
                                    transition={{
                                        duration: 1,
                                        repeat: Infinity,
                                        ease: "easeInOut",
                                    }}
                                >
                                </motion.span>

                                Download Brochure
                            </button>
                        </div>
                    </div>
                </div>
            </section>

            {/* One Kind Section */}
            <section className="one-of-kind-section py-5">
                <div className="container">
                    {/* Heading */}
                    <motion.div
                        className="text-center mb-5"
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.6 }}
                    >
                        <h2 className=" mb-2 billie-eilish text-cream">World-Class Amenities at One by MSN Neopolis</h2>
                        <div className="mx-auto mb-3" style={{ width: "60px", height: "2px", backgroundColor: "#d4af37" }} />
                        <p className="text-muted mx-auto" >
                            The <strong>amenities at One by MSN</strong> are thoughtfully curated to deliver an unmatched luxury lifestyle in the heart of <strong>Neopolis, Kokapet Hyderabad</strong>. Designed to complement the elegance of the residences, every amenity  sophistication, comfort, and contemporary living.
                        </p>
                    </motion.div>

                    <div className="row align-items-start">
                        {/* Left PNG */}
                        <div className="col-md-2 d-none d-md-block">
                            <motion.img
                                src={modalLeftPNG}
                                alt="One by MSN high rise towers near Financial District Hyderabad"
                                className="img-fluid"
                                initial={{ opacity: 0, x: -50 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 0.6 }}
                            />
                        </div>

                        {/* Features Grid */}
                        <div className="col-md-10">
                            <div className="row g-3">
                                {features.map((feature, i) => (
                                    <div key={i} className="col-12 col-sm-6 col-md-4">
                                        <motion.div
                                            className="card h-100 shadow-sm border-0 rounded-4 overflow-hidden cursor-pointer"
                                            initial={{ opacity: 0, y: 20 }}
                                            whileInView={{ opacity: 1, y: 0 }}
                                            whileHover={{ y: -6 }}
                                            viewport={{ once: true }}
                                            transition={{ duration: 0.4, delay: i * 0.08 }}
                                            onClick={() => setModalImg(feature.img)}
                                        >
                                            {/* Image */}
                                            <div className="overflow-hidden">
                                                <img
                                                    src={feature.img}
                                                    alt={feature.alt}
                                                    className="card-img-top img-fluid"
                                                    loading="lazy"
                                                />

                                            </div>

                                            {/* Body */}
                                            <div className="card-body bg-maroon text-cream p-4">
                                                <h5 className="card-title billie-eilish text-cream mb-2">
                                                    {feature.title}
                                                </h5>

                                                {/* Description with background */}
                                                <div className="bg-warning bg-opacity-10 border-start border-3 border-warning rounded-3 p-3">
                                                    <p className="card-text text-white small mb-0">
                                                        {feature.subtitle}
                                                    </p>
                                                </div>
                                            </div>
                                        </motion.div>

                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>

                {/* Modal */}
                {modalImg && (
                    <div
                        className="modal show fade d-block"
                        tabIndex="-1"
                        onClick={() => setModalImg(null)}
                        style={{
                            backgroundColor: "rgba(0,0,0,0.9)",
                            zIndex: 1055
                        }}
                    >
                        <div
                            className="modal-dialog modal-dialog-centered modal-xl"
                            onClick={(e) => e.stopPropagation()}
                        >
                            <div
                                className="position-relative mx-auto"
                                style={{
                                    backgroundColor: "#000",
                                    maxWidth: "900px",
                                    borderRadius: "12px",
                                    overflow: "hidden"
                                }}
                            >
                                {/* CLOSE ICON */}
                                <button
                                    className="position-absolute top-0 end-0 m-3 btn bg-maroon text-white btn-sm rounded-circle"
                                    style={{ zIndex: 3 }}
                                    onClick={() => setModalImg(null)}
                                >
                                    <i className="bi bi-x fs-5"></i>
                                </button>

                                {/* IMAGE */}
                                <motion.img
                                    src={modalImg}
                                    alt="Ultra luxury apartments in Neopolis Kokapet Hyderabad exterior view"
                                    className="d-block w-100"
                                    style={{
                                        height: "520px",
                                        objectFit: "cover",
                                        backgroundColor: "#000"
                                    }}
                                    initial={{ scale: 0.95, opacity: 0 }}
                                    animate={{ scale: 1, opacity: 1 }}
                                    transition={{ duration: 0.3 }}
                                />

                                {/* TITLE */}
                                <div
                                    className="text-center bg-maroon text-white py-3"
                                    style={{
                                        fontSize: "16px",
                                        letterSpacing: "0.5px"
                                    }}
                                >
                                    {currentTitle}
                                </div>
                            </div>
                        </div>
                    </div>
                )}



            </section>

            {/* Neopolis Image */}
            <section className="neoplis-img container py-5">
                {/* HEADING */}
                <motion.div
                    className="text-center mb-5"
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6, ease: "easeOut" }}
                >
                    <h2 className="mb-2 billie-eilish">Prime Location – One by MSN Neopolis, Kokapet Hyderabad</h2>
                    <div
                        className="mx-auto mb-3"
                        style={{
                            width: "60px",
                            height: "2px",
                            backgroundColor: "#d4af37"
                        }}
                    />
                    <p className="text-muted mx-auto mb-0" >
                        <strong>One by MSN</strong> is strategically located in <strong>Neopolis, Kokapet Hyderabad</strong>, one of the most prestigious and fastest-growing luxury residential destinations in the city. This prime location places the project at the center of  premium real estate corridor, offering unmatched connectivity and long-term value.
                    </p>
                </motion.div>
                <img src={NeopolisImg} className="img-fluid" alt="One by MSN clubhouse and premium lifestyle amenities Hyderabad" />
            </section>

            {/* Gallery Section */}
            <section id="gallery" className="gallery-section py-5 bg-light">
                <div className="container">

                    {/* HEADING */}
                    <motion.div
                        className="text-center mb-5"
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.6, ease: "easeOut" }}
                    >
                        <h2 className="mb-2 billie-eilish">Gallery – One by MSN Luxury Residences</h2>
                        <div
                            className="mx-auto mb-3"
                            style={{
                                width: "60px",
                                height: "2px",
                                backgroundColor: "#d4af37"
                            }}
                        />
                        <p className="text-muted mx-auto" >
                            The gallery of <strong>One by MSN</strong> offers a visual journey through architectural brilliance, refined interiors,  thoughtfully designed lifestyle spaces. Each image captures the essence of ultra-luxury living in <strong>Neopolis, Kokapet Hyderabad</strong>.
                        </p>
                    </motion.div>

                    {/* GRID */}
                    <motion.div
                        className="row g-4"
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true }}
                        variants={{
                            hidden: {},
                            visible: {
                                transition: {
                                    staggerChildren: 0.12
                                }
                            }
                        }}
                    >
                        {galleryBlocks.map((item, index) => (
                            <motion.div
                                key={index}
                                className="col-6 col-md-4 col-lg-3"
                                variants={{
                                    hidden: { opacity: 0, y: 30 },
                                    visible: {
                                        opacity: 1,
                                        y: 0,
                                        transition: { duration: 0.5, ease: "easeOut" }
                                    }
                                }}
                            >
                                <motion.div
                                    className="position-relative rounded-4 overflow-hidden shadow-sm"
                                    whileHover="hover"
                                    initial="rest"
                                    animate="rest"
                                    variants={{
                                        rest: {
                                            boxShadow: "0 10px 25px rgba(0,0,0,0.08)"
                                        },
                                        hover: {
                                            boxShadow: "0 18px 40px rgba(0,0,0,0.18)"
                                        }
                                    }}
                                    transition={{ duration: 0.3 }}
                                >
                                    {/* IMAGE */}
                                    <motion.img
                                        src={item.img}
                                       alt={item.alt}
                                        className="img-fluid w-100"
                                        style={{
                                            height: "260px",
                                            objectFit: "cover"
                                        }}
                                        variants={{
                                            rest: { scale: 1 },
                                            hover: { scale: 1.08 }
                                        }}
                                        transition={{ duration: 0.5, ease: "easeOut" }}
                                    />

                                    {/* TITLE OVERLAY */}
                                    <motion.div
                                        className="position-absolute bottom-0 start-0 w-100 text-white px-3 py-2"
                                        variants={{
                                            rest: { opacity: 0, y: 10 },
                                            hover: { opacity: 1, y: 0 }
                                        }}
                                        transition={{ duration: 0.3, ease: "easeOut" }}
                                        style={{
                                            background:
                                                "linear-gradient(to top, rgba(0,0,0,0.75), rgba(0,0,0,0))",
                                            fontSize: "14px",
                                            letterSpacing: "0.4px"
                                        }}
                                    >
                                        {item.title}
                                    </motion.div>
                                </motion.div>
                            </motion.div>
                        ))}
                    </motion.div>
                </div>
            </section>


            {/* FAQ's Section */}
            <section className="faq-section py-5 bg-white">
                <div className="container">

                    {/* HEADING */}
                    <motion.div
                        className="text-center mb-5"
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.6 }}
                    >
                        <h2 className="billie-eilish">Frequently Asked Questions</h2>
                        <div
                            className="mx-auto mb-3"
                            style={{ width: 60, height: 2, backgroundColor: "#d4af37" }}
                        />
                        <p className="text-muted mx-auto" >
                            Answers to common queries about One by MSN.
                        </p>
                    </motion.div>

                    {/* FAQ CONTENT */}
                    <div className="row justify-content-center">
                        <div className="col-12 col-lg-8">

                            <div className="accordion" id="msnFaqAccordion">
                                {msnFaqs.map((item, idx) => (
                                    <motion.div
                                        key={idx}
                                        className="accordion-item faq-item mb-3"
                                        initial={{ opacity: 0, y: 20 }}
                                        whileInView={{ opacity: 1, y: 0 }}
                                        viewport={{ once: true }}
                                        transition={{ duration: 0.4, delay: idx * 0.08 }}
                                    >
                                        <h2 className="accordion-header" id={`heading${idx}`}>
                                            <button
                                                className={`accordion-button ${idx === 0 ? "" : "collapsed"}`}
                                                type="button"
                                                data-bs-toggle="collapse"
                                                data-bs-target={`#collapse${idx}`}
                                                aria-expanded={idx === 0}
                                                aria-controls={`collapse${idx}`}
                                            >
                                                {item.question}
                                            </button>
                                        </h2>

                                        <div
                                            id={`collapse${idx}`}
                                            className={`accordion-collapse collapse ${idx === 0 ? "show" : ""}`}
                                            aria-labelledby={`heading${idx}`}
                                            data-bs-parent="#msnFaqAccordion"
                                        >
                                            <div className="accordion-body">
                                                {item.answer}
                                            </div>
                                        </div>
                                    </motion.div>
                                ))}

                            </div>

                        </div>
                    </div>

                </div>
            </section>



            {/* Contact Section */}
            {/* Contact Section */}
            <section id="contact" className="contact-section py-5 bg-white">
                <div className="container">

                    {/* HEADING */}
                    <motion.div
                        className="text-center mb-5"
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.6, ease: "easeOut" }}
                    >
                        <h2 className="mb-2 billie-eilish">Contact One by MSN – Luxury 4 BHK Apartments in Neopolis</h2>
                        <div
                            className="mx-auto mb-3"
                            style={{
                                width: "60px",
                                height: "2px",
                                backgroundColor: "#d4af37"
                            }}
                        />
                        <p className="text-muted mx-auto" >
                            Get in touch with us to know more about <strong>One by MSN</strong>, an ultra-luxury residential project offering spacious <strong>4 BHK apartments in Neopolis, Kokapet Hyderabad</strong>. Connect with our experts to receive detailed floor plans, pricing information, availability, and exclusive offers for this premium development by <strong>MSN Realty</strong>.
                        </p>
                    </motion.div>

                    {/* CONTENT */}
                    <div className="row g-5 align-items-stretch">

                        {/* MAP */}
                        <motion.div
                            className="col-12 col-lg-7"
                            initial={{ opacity: 0, x: -40 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.6, ease: "easeOut" }}
                        >
                            <div className="h-100 rounded-4 overflow-hidden shadow-sm">
                                <iframe
                                    title="Project Location Map"
                                    src="https://www.google.com/maps?q=Neopolis%20Kokapet%20Hyderabad&output=embed"
                                    width="100%"
                                    height="100%"
                                    style={{
                                        minHeight: "420px",
                                        border: 0
                                    }}
                                    allowFullScreen
                                    loading="lazy"
                                    aria-label="One by MSN Project Location Map Neopolis Kokapet Hyderabad"
                                    referrerPolicy="no-referrer-when-downgrade"
                                />
                            </div>
                        </motion.div>

                        {/* FORM */}
                        <motion.div
                            className="col-12 col-lg-5 border-0 overflow-hidden"
                            initial={{ scale: 0.85, opacity: 0 }}
                            animate={{ scale: 1, opacity: 1 }}
                            transition={{ duration: 0.3, ease: "easeOut" }}
                        >
                            <div className="bg-maroon shadow-lg rounded-4 p-4 p-lg-5 position-relative">

                                {/* HEADER */}
                                <div className="text-center mb-4">
                                    <h4 className="fw-bold text-white mb-2">
                                        ONE by MSN
                                    </h4>
                                    <p className="text-white-50 mb-0">
                                        Premium plotted development surrounded by nature
                                    </p>
                                </div>

                                {/* FORM */}
                                <div className="modal-body p-0">
                                    <ContactForm onSuccess={closeModal} />
                                </div>

                                {/* 📞 CALL HIGHLIGHT */}
                                <div className="d-flex align-items-center gap-3 mt-4 p-3 bg-light rounded">
                                    <div
                                        className="rounded-circle bg-white border d-flex align-items-center justify-content-center"
                                        style={{ width: "44px", height: "44px" }}
                                    >
                                        📞
                                    </div>

                                    <div>
                                        <small className="text-muted">Call for Instant Details</small>
                                        <h5 className="fw-bold mb-0">
                                            <a
                                                href="tel:+919652389333"
                                                className="text-decoration-none text-dark"
                                            >
                                                +91 96523 89333
                                            </a>
                                        </h5>
                                    </div>
                                </div>

                            </div>
                        </motion.div>

                    </div>
                </div>
            </section>

            {/* Footer Section */}
            <footer className="bg-gradient text-white py-4">
                <div className="container">
                    <div className="text-center">

                        <p className="fw-semibold mb-3">
                            © 2026 <span className="text-warning">MSN Realty</span>. All Rights Reserved.
                        </p>

                        <p className="small mb-3 mx-auto" style={{ maxWidth: "1100px" }}>
                            Disclaimer: This website is not the official RERA website of the project and is intended
                            solely for informational purposes. The content displayed is managed by a RERA-authorized
                            real estate channel partner. <strong>One by MSN</strong> is a RERA-registered project.
                            Channel Partner RERA Registration Number: Coming Soon | Project RERA Registration Number:
                            Coming Soon.
                        </p>

                        <p className="small mb-3 mx-auto" style={{ maxWidth: "1100px" }}>
                            The prices, layouts, specifications, images, visuals, and other details mentioned on
                            this website are subject to change without prior notice. Availability of units cannot be
                            guaranteed. All images and visuals are for representational purposes only and may not
                            accurately reflect the actual project.
                        </p>

                        <p className="small mb-3 mx-auto" style={{ maxWidth: "1100px" }}>
                            We may share your information with RERA-registered developers and authorized partners
                            for further communication and processing. Updates related to the project may be sent to
                            the mobile number or email address provided by you.
                        </p>

                        <p className="small mb-3 mx-auto" style={{ maxWidth: "1100px" }}>
                            All content on this website, including text, design, images, and information, is
                            protected under applicable copyright and intellectual property laws. Unauthorized use
                            or reproduction is strictly prohibited.
                        </p>

                        <p className="small mb-0 mx-auto" style={{ maxWidth: "1100px" }}>
                            For accurate and up-to-date information regarding pricing, availability, or services,
                            please contact us directly through the contact details provided on this website.
                        </p>

                    </div>
                </div>
            </footer>

            {/* WhatsApp Integration */}
            <a
                href="https://wa.me/919652389333?text=Hello%20I%20am%20interested%20in%20One%20by%20MSN"
                target="_blank"
                rel="noopener noreferrer"
                className="whatsapp-float"
                aria-label="Chat on WhatsApp"
            >
                <i className="bi bi-whatsapp"></i>
            </a>

        </>


    );
}
